import {
  observedActions,
  observedActionsTriggers
} from './config/observed_actions'

export function createStorageListener (store, history) {
  return event => {
    const { key, newValue, url } = event
    // console.log('evento', event)
    if (key === 'MIDDLEWARE_ACTION') {
      // console.log('evento key', key, newValue)
      const { action } = JSON.parse(newValue)
      if (action && observedActions.includes(action.type)) {
        store.dispatch({ ...action, type: `${action.type}_PREVENT` })
        const trigger = observedActionsTriggers[action.type]
        if (typeof trigger === 'function') {
          trigger(store, history)
        }
      }
    }
    if (key === 'jwToken') {
      // Key que indica que el token ya no es valido
      // console.log('evento key', key, url)
      history.push(url)
      history.go(0)
      window.location.reload()
    }
  }
}
